// src/utils/profileTabs.js

/**
 * Compat com profile.tabs:
 * - undefined => true (não bloqueia)
 * - boolean => true/false
 * - object => { enabled: true/false }
 */
export function isTabEnabled(profile, key) {
    const t = profile?.tabs?.[key];

    if (t === undefined) return true;
    if (typeof t === 'boolean') return t;
    if (t && typeof t === 'object') return t.enabled !== false;

    return true;
}

/**
 * Filtra tabsConfig por:
 * - regra local do tabsConfig: enabled !== false
 * - regra do profile: isTabEnabled(profile, key)
 */
export function filterTabsByProfile(tabsConfig = [], profile, parametro) {
    return (tabsConfig || [])
        .filter((t) => t && t.enabled !== false) // Regra estática
        .filter((t) => t.show !== false) // Regra dinâmica (ex: isIndustria)
        .filter((t) => isTabEnabled(profile, t.key)); // Regra do perfil/permissão
}

/**
 * Sugestão: define aba inicial com fallback.
 */
export function getInitialTabKey(profile, { defaultKey = 'cabecalho', restaurantKey = 'itens' } = {}) {
    if (profile?.layout === 'restaurante') return restaurantKey;
    return defaultKey;
}
